/**
 * The path used as MSAL redirect URI and health check endpoint.
 * Must match the URI registered in Azure Portal / App Registration.
 */
export const HEALTH_REDIRECT_URI = '/healt'
